<div class="app-filter-block" [ngClass]="{ '-sticky': sticky }">
  <div class="filter-container">
    <h2 *ngIf="title">{{ title }}</h2>
    <ng-content select="[filter]"></ng-content>
    <div class="align-right">
      <ng-content select="[filter-end]"></ng-content>
    </div>
  </div>
</div>